export const sortArray = <T>(arr: T[] | undefined, sortFunc: ((a: T, b: T) => number) | undefined, sortKey: keyof T, direction?: "asc" | "desc" | "up" | "down" | "ascending" | "descending") => {
    const isAscending = !direction || direction === "asc" || direction === "up" || direction === "ascending";

    return arr?.sort((a, b) => {
        if (sortFunc) {
            return sortFunc(a, b) * (isAscending ? 1 : -1);
        }
        const aVal = a[sortKey];
        const bVal = b[sortKey];

        if (aVal > bVal) {
            return isAscending ? 1 : -1;
        } else if (aVal < bVal) {
            return isAscending ? -1 : 1;
        }
        return 0;
    })
}